export const userActiveNavItems = {
    archive: 'archive',
    researchAreas: 'researchAreas',
};

export const sharedActiveNavItems = {
    changelog: 'changelog',
    dashboard: 'dashboard',
    projectVersionHistory: 'projectVersionHistory',
};

export const supervisorActiveNavItems = {
    supervisorResearchAreas: 'supervisionResearchAreas',
    supervisions: 'supervisions',
    archive: 'archive',
};

export const adminActiveNavItems = {
    adminProjects: 'adminProjects',
    adminSupervisors: 'adminSupervisors',
    adminSetup: 'adminSetup',
    adminArchive: 'adminArchive',
};
